import React, { Component } from "react";
import { ModalBody, Modal } from "reactstrap";
import { Images } from "../shared/Images";

const imageStyle = (image) => {
  const splittedName = image.split(".");
  return {
    backgroundImage: `url(${splittedName[0] + "-min." + splittedName[1]})`,
  };
};

class Gallery extends Component {
  constructor(props) {
    super(props);

    this.state = {
      isModalOpen: false,
      selectedImg: null,
      images: Images,
      opened: false,
    };

    this.toggleModal = this.toggleModal.bind(this);
    this.imageSelected = this.imageSelected.bind(this);
  }

  componentDidMount() {
    window.scrollTo({ top: 0, behavior: "auto",});
  } 

  toggleModal() {
    this.setState({
      isModalOpen: !this.state.isModalOpen,
    });
  }

  imageSelected(imageSrc) {
    this.setState({
      selectedImg: imageSrc,
    });
    this.toggleModal();
  }

  render() {

    const imgs = this.state.images.map((image) => {
      return (
        <GalleryElem
          key={image.id}
          image={image.path}
          imageSelected={this.imageSelected}
        />
      );
    });

    return (
      <div>
        <h2 className="page-title d-flex py-3">Галерея</h2>
        <div className="gallery container-fluid d-flex justify-content-around">
          {imgs}
        </div>
        <Modal
          className="gallery-modal mx-auto"
          isOpen={this.state.isModalOpen}
          toggle={this.toggleModal}>
          <ModalBody>
            <div className="selected-div">
              <div className="hfc">
                <button
                  onClick={this.toggleModal}
                  style={{ "background-color": "#2d2b30", "color" : "whitesmoke"}}
                  type="button"
                  className="close"
                  data-dismiss="modal"
                  aria-label="Close">
                  <span aria-hidden="true">&times;</span>
                </button>
                <img className="shown-img" src={this.state.selectedImg}/>
              </div>
            </div>
          </ModalBody>
        </Modal>
      </div>
    );
  }
}

class GalleryElem extends Component {
  constructor(props) {
    super(props);

    this.state = {
      image: this.props.image,
      imageSelected: this.props.imageSelected,
    };
  }

  render() {
    const image = this.state.image;

    return (
      <div className="parent-frame col-sm-5 mb-3 mb-md-4">
      <div
        className="one-frame"
        onClick={() => this.state.imageSelected(image)}
        style={imageStyle(image)}
      ></div>
      </div>
    );
  }
}

export default Gallery;
